import React from 'react';

import styled from '@emotion/styled';

const StyledDiv = styled.div({
    background: 'red',
    bottom: 0,
    height: '50px',
    left: 0,
    opacity: 0.7,
    position: 'absolute',
    transition: 'opacity .5s',
    width: '100%',
    borderRadius: '0 0 5px 5px',
    zIndex: 3,
});

const WrapperDiv = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexFlow: 'column-reverse',
    flex: '1 100%',
});

const StyledSpan = styled.span({
    display: 'block',
    textAlign: 'center',
    fontSize: 'rem',
    '@media (min-width: 768px)': { fontSize: '2em' },
});

interface DiscStatusProps {
    label: string;
}

export function DiscStatus({ label }: DiscStatusProps): React.JSX.Element {
    return (
        <StyledDiv>
            <WrapperDiv>
                <StyledSpan>{label}</StyledSpan>
            </WrapperDiv>
        </StyledDiv>
    );
}
